import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { Box, Grow } from '@mui/material';
import useTimeStore from '../ZustandProvider';

const LoadingComponent = () => {
  const setAdjustMap = useTimeStore(state => state.setAdjustMap);

  const [progress, setProgress] = React.useState(0);
  const [cargando, setCargando] = React.useState(true);
  let timer;

  const tiempoCargando = 400;
  const A = () => {
    timer =
      !timer &&
      setInterval(() => {
        setProgress(prevProgress => (prevProgress >= 100 ? prevProgress : prevProgress + 10));
      }, tiempoCargando / 10);
    if (progress >= 100) {
      setAdjustMap(false);
      setTimeout(() => {
        setCargando(false);
      }, 800);
      setTimeout(() => {
        setAdjustMap(true);
      }, 500);

      clearInterval(timer);
    }
  };

  React.useEffect(() => {
    A();
    return () => clearInterval(timer);
  }, [progress]);

  const icon = (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundColor: '#f8f9fa',
        zIndex: 10000,
        position: 'fixed'
      }}
    >
      <Box height="30vh" />
      <center>
        <img
          className="d-inline-block align-top"
          src="/ias-logo/maps.png"
          height="80"
          width="auto"
          alt="logo"
        />
      </center>
      <Box sx={{ display: 'flex', mt: 5, alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ width: '25%' }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#2A3F90'
              },
              backgroundColor: '#E0E0E0'
            }}
          />
        </Box>
        {/* <Box sx={{ minWidth: 35, ml: 1 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            progress
          )}%`}</Typography>
        </Box> */}
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <Grow appear={false} in={cargando} timeout={{ exit: 1000 }}>
        {icon}
      </Grow>
    </Box>
  );
};

export default LoadingComponent;
